import { MenuPoint } from '@agilox/ui-common';
import { manageMenuPoints } from './menupoints';

export const mobileMenuPoints: MenuPoint[] = [
	manageMenuPoints.users,
	{
		name: 'menu.menu',
		url: '',
		icon: 'menu_hamburger',
		roles: [],
		submenus: [
			manageMenuPoints.users,
			manageMenuPoints.vehicles,
			manageMenuPoints.notifications,
			manageMenuPoints.help,
			manageMenuPoints.logout,
		],
	},
];
